import { getField, updateField } from "vuex-map-fields";

import API from "@/api";

export const state = () => ({
  // table
  fontes: [],
  loadingTable: false,
  // filtros
  textSearchDescription: "",
  searchFonte: [],
  fonteMap: {},

  // paginacao
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  currentPage: 1,
});

export const getters = {
  getField,
  formatFonte: (state) => (code) => formatFonte(state, code),
};

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };

  config.params.append("size", state.pagination.size);
  config.params.append("page", state.currentPage - 1);
  config.params.append("sort", "dsFonte");

  if (state.textSearchDescription) {
    config.params.append("description", state.textSearchDescription.toString());
  }

  return config;
}

function formatFonte(state, enumCode) {
  if (Object.keys(state.fonteMap).length === 0 || !state.fonteMap[enumCode]) {
    return enumCode;
  } else {
    return state.fonteMap[enumCode];
  }
}

function objectToMap(status, objectName) {
  let map = {};
  status.forEach((elem) => {
    if (objectName == "fonte") {
      map[elem.dsFonte] = elem.label;
    } else if (objectName == "dataset") {
      map[elem.dsDataset] = elem.label;
    } else {
      map[elem.code] = elem.label;
    }
  });
  return map;
}

export const actions = {
  async get({ dispatch, state, commit, rootState }, payload) {
    commit("updateField", { path: "pagination.offset", value: 0 });
    commit("updateField", { path: "fontes", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });

    const result = await API.axios.get(
      "/bff/api/v1/controle-cargas/fontes",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
    }
    if (result.data.content) {
      commit("updateField", { path: "fontes", value: result.data.content });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getPage({ state, commit, rootState }, payload) {
    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/bff/api/v1/controle-cargas/fontes",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      // update table items
      commit("updateField", { path: "fontes", value: result.data.content });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async createFonte({ dispatch, state }, { fonteForm }) {
    const response = await API.axios.post(
      `/bff/api/v1/controle-cargas/fontes`,
      fonteForm
    );
    return response;
  },

  async getFonteList({ dispatch, state, commit, rootState }, payload) {
    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/fontes?unpaged=true&sort=dsFonte`
    );

    if (result.status === 200) {
      commit("updateField", {
        path: "searchFonte",
        value: result.data?.content,
      });
      commit("updateField", {
        path: "fonteMap",
        value: objectToMap(result.data?.content, "fonte"),
      });
    }
  },

  async updateFonte({ dispatch, state }, { fonteForm }) {
    const response = await API.axios.put(
      `/bff/api/v1/controle-cargas/fontes/${fonteForm.dsFonte}`,
      fonteForm
    );
    return response;
  },

  async deleteFonte({ dispatch, state }, dsFonte) {
    const response = await API.axios.delete(
      `/bff/api/v1/controle-cargas/fontes/${dsFonte}`
    );
    return response;
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, payload) {
    state.pagination.size = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
